import {useEffect, useRef} from 'react';

// taken from https://blog.logrocket.com/how-to-get-previous-props-state-with-react-hooks/
const usePrevious = <T>(value: T) => {
  const ref = useRef<T>(undefined);
  useEffect(() => {
    ref.current = value;
  });

  // oxlint-disable-next-line react/react-compiler -- reading the previous-render value during render is the entire point of usePrevious
  return ref.current;
};

export default usePrevious;
